import { useContext, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import './orgTripDetails.css';
import DetailsTabs from '../../components/detailsTabs/DetailsTabs';
import DetailsImageDisplay from '../../components/detailsImageDisplay/DetailsImageDisplay';
import fetchOrgTripData from './orgTripDetailsFun/fetchOrgTripData';
import OrgTripDateTab from '../../components/orgTripDateTab/OrgTripDateTab';
import { OrgDatesContext } from '../../context/OrgDatesContest';
import EmptyPage from '../../components/empty-page/emptyPage';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import BackIcon from '../../assets/icons/trvto_ArrowBack.svg';
import { useNavigate } from 'react-router-dom';
import { standardDate } from '../../utils/formatDate';
import DetailsTab from '../../components/orgDetails/detailsTab/DetailsTab';

export default function OrgTripDetails() {
    const navigate = useNavigate();
    const [packData, setPackData] = useState({});
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const refresh = () => {
        setLoad(!load);
    };
    const context = {
        role: 'org',
        flow: 'trip'
    };
    const { dates, setDates } = useContext(OrgDatesContext);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        fetchOrgTripData(setLoading, setPackData, setDates);
        //eslint-disable-next-line
    }, [load]);

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <button className='backBtn' onClick={() => navigate('/org/my-pack')}>
                <img src={BackIcon} alt='back' /> Back to Packages
            </button>
            {Object.keys(packData).length !== 0 ? (
                <>
                    <div className='orgTripDetailsLayout'>
                        <div className='tripDetailsMainRow'>
                            <div className='tripDetailsLeft'>
                                <div className='orgTripDetailsHeadingDiv'>
                                    <div className='flex'>
                                        <h1 className='detailsImageDisplayName'>{packData.title}</h1>
                                        {/* <Share onClick={(e) => share(e)} /> */}
                                    </div>
                                    <div>
                                        <div className='tripBriefInfo'>
                                            <span className='tripDetailsSubDetails tripDetailsOrgName'>
                                                {packData?.organizerName ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.days + 'D/' + packData?.nights + 'N'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {dates.length !== 0 && standardDate(dates[0]?.startDate?.split('T')[0])}{' '}
                                                Onwards
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.startTime ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.stay ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.food ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.type[0] ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                {packData?.quickView?.difficulty ?? 'N/A'}
                                            </span>
                                            <span className='tripDetailsDot'></span>
                                            <span className='tripDetailsSubDetails'>
                                                <ReviewStars rating={packData?.rating} className='reviews' />
                                                <span>{packData?.rating ?? 'N/A'}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <DetailsImageDisplay imageData={packData.images} stayImages={packData?.stayDetails?.images} />
                                <DetailsTab context={context} data={packData} refresh={refresh} whichSection={'org'} />
                            </div>
                            {packData.status === 'active' && (
                                <div className='tripDetailsBookingUser'>
                                    <OrgTripDateTab
                                        price={packData.price[0]}
                                        packData={packData}
                                        refresh={refresh}
                                        isExpanded={isExpanded}
                                        setIsExpanded={setIsExpanded}
                                    />
                                </div>
                            )}
                        </div>
                    </div>{' '}
                </>
            ) : (
                <EmptyPage />
            )}
        </div>
    );
}
